import {Component, OnInit} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {UntypedFormBuilder} from '@angular/forms';
import {Observable} from 'rxjs';
import {UxInteractions} from '@app/4dm1n/users-list/store/users-list.reducers';
import {currentUserContributorSurveysDetails, currentUserDetail, currentUxInteraction, ITabSurveyDetails} from '@app/4dm1n/users-list/store/users-list.selector';
import {IAdm1nSurveyMongoTempState, IAdm1nSurveyTempState} from '@app/4dm1n/users-list/store/_model';
import {UsersListService} from '@app/4dm1n/users-list/users-list.service';

@Component({
    selector: 'app-surveys-details',
    templateUrl: './surveys-details.component.html',
    styleUrls: ['./surveys-details.component.scss'],
    standalone: false
})
export class SurveysDetailsComponent extends OnDestroyMixin implements OnInit {

  displayPartialDetail = false;
  currentPartial: IAdm1nSurveyMongoTempState = null;

  allreadyRepliedId: string[] = [];

  uxInteractions$: Observable<UxInteractions> = this.store.select(currentUxInteraction).pipe(untilComponentDestroyed(this));
  currentUser$: Observable<any> = this.store.select(currentUserDetail).pipe(untilComponentDestroyed(this));
  surveysDetails$: Observable<ITabSurveyDetails> = this.store.select(currentUserContributorSurveysDetails).pipe(untilComponentDestroyed(this));

  constructor(
    private store: Store<AppState>,
    private formBuilder: UntypedFormBuilder,
    private usersListService: UsersListService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.surveysDetails$.pipe(untilComponentDestroyed(this)).subscribe((data) => {
      this.allreadyRepliedId = data.responses.map((aSurvey) => {
        return `${aSurvey.surveyId}`;
      });
    });

  }

  hidePopOver() {
    this.displayPartialDetail = false;
  }

  selectPartial(e) {
    this.currentPartial = e.data;
    this.displayPartialDetail = true;
  }

  //
  // Génère une URL direct!
  //
  getUrl(userToken: string, surveyId: number = null, partialId: number = null): string {

    const params = [];
    params.push(
      {
        key: 'redirectAction', value: 'displaySurveyWithPartialId'
      }
    );
    params.push(
      {
        key: 'surveyId', value: surveyId
      }
    );
    params.push(
      {
        key: 'partialId', value: partialId
      }
    );
    // if (this.modeTestSelected.value === true) {
    //   params.push(
    //     {
    //       key: 'debug', value: '123'
    //     }
    //   );
    // }
    return this.usersListService.generateLoginAsUrl(userToken, params);
  }


}
